/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* Cookie Consent (DSG/kDSG compliant) */
(function () {
    var consentKey = 'gh_cookie_consent';
    var banner = document.getElementById('gh-cookie-consent');
    var acceptBtn = document.getElementById('gh-cookie-accept');
    var rejectBtn = document.getElementById('gh-cookie-reject');

    if (!banner || !acceptBtn || !rejectBtn) return;

    var consent = localStorage.getItem(consentKey);

    if (consent === 'accepted' || consent === 'rejected') {
        banner.style.display = 'none';
        if (consent === 'accepted') {
            loadAnalytics();
        }
        return;
    }

    banner.style.display = 'block';

    acceptBtn.addEventListener('click', function () {
        localStorage.setItem(consentKey, 'accepted');
        banner.style.display = 'none';
        loadAnalytics();
    });

    rejectBtn.addEventListener('click', function () {
        localStorage.setItem(consentKey, 'rejected');
        banner.style.display = 'none';
    });

    function loadAnalytics() {
        if (window.gtagLoaded) return;
        window.gtagLoaded = true;

        var libScript = document.createElement('script');
        libScript.async = true;
        libScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-VJJ5ZG0FW4';
        document.head.appendChild(libScript);

        var gaScript = document.querySelector('script[data-ga-consent]');
        if (gaScript) {
            var configScript = document.createElement('script');
            configScript.textContent = gaScript.textContent;
            document.head.appendChild(configScript);
        }
    }
})();